import './_CardPropertyItem.scss';
import { ICardPropertiesItemProps } from './types';
import { Checkbox, Tooltip } from 'kui';
import * as React from 'react';
import { CLASS_BOARD_DETAILS } from '../../../../constants';
import { escape } from 'underscore';
import { EAsidePanelProperty } from '../../../../../asidePanel/components/AsidePanel/types';
import { AnalyzeRender } from '../../../../../../helpers/memoizeHelper';
// @ts-ignore
const analyzeRender = window.Settings.development ? new AnalyzeRender(`CardPropertyItem`) : null;

export const CardPropertyItem = ({
    isReadonly,
    propertyKey,
    name,
    isAdmin,
    isDefaultOnly,
    isDisallow,
    isPreview,
    isPreviewOnly,
    isRequiredOnly,
    isDefault,
    isRequired,
    isViewOnPreview,
    option,
    onDefaultToggle,
    onPreviewToggle,
    onShowBoardLimitSnackbarIfNeeded,
    onRequiredToggle,
    onDisallowClick
}: ICardPropertiesItemProps) => {
    if (analyzeRender) analyzeRender.call(propertyKey);
    const className = CLASS_BOARD_DETAILS + '__card-properties';
    const classItem = className + '-item';
    const classDisabled = classItem + '--disabled';
    const classCheckboxes = className + '-checkboxes';
    const classSingle = classCheckboxes + '--single';
    const classCheckbox = className + '-checkbox';
    const classChecked = classCheckbox + '--checked';
    const classText = classItem + '-text';
    const classWrapper = classCheckbox + '-wrapper';
    const classDisallow = classWrapper + '--disallow';

    return (
        <div className={classItem + '-wrapper'} onClick={onShowBoardLimitSnackbarIfNeeded}>
            <div
                className={`
                    ${classItem}
                    ${isReadonly ? classDisabled : ''}
                `}
            >
                <Tooltip
                    direction={'down'}
                    value={name ? escape(name) : null}
                    isNoWrap
                    isNoEvents
                >
                    <span className={classText}>
                        {name}
                    </span>
                </Tooltip>
                <span
                    className={`
                        ${classCheckboxes}
                        ${isDefaultOnly ? classSingle : ''}
                    `}
                >
                     <div
                         className={`
                             ${classWrapper}
                             ${isDisallow ? classDisallow : ''}
                         `}
                         onClick={isDisallow ? onDisallowClick : () => {}}
                     >
                         {!isPreviewOnly &&
                             <Checkbox
                                 className={`
                                ${classCheckbox}
                                ${isDefault ? classChecked : ''}
                             `}
                                 checked={isDefault || isRequiredOnly}
                                 disabled={isReadonly || isRequiredOnly}
                                 onChange={() => onDefaultToggle(propertyKey as EAsidePanelProperty, option)}
                             />
                         }
                     </div>
                    <div
                        className={`
                            ${classWrapper}
                            ${isDisallow ? classDisallow : ''}
                        `}
                        onClick={isDisallow ? onDisallowClick : () => {}}
                    >
                        {!isPreviewOnly && !isDefaultOnly &&
                            <Checkbox
                                className={`
                                    ${classCheckbox}
                                    ${isRequired ? classChecked : ''}
                                `}
                                checked={isRequired}
                                disabled={isReadonly}
                                onChange={() => !isDisallow && onRequiredToggle(propertyKey as EAsidePanelProperty, option)}
                            />
                        }
                    </div>
                    <div className={classWrapper}>
                         {(isPreview || isPreviewOnly) &&
                             <Checkbox
                                 className={`
                                     ${classCheckbox}
                                     ${isViewOnPreview ? classChecked : ''}
                                 `}
                                 checked={isViewOnPreview}
                                 disabled={!isAdmin}
                                 onChange={() => onPreviewToggle(propertyKey)}
                             />
                         }
                    </div>
                </span>
            </div>
        </div>
);
}
